import createDevNotice from 'www/utils/executors/createDevNotice'

/**
 * @param {object} options -
 * @param {string} options.module - название модуля, в котором происходит проверка
 * @param {object} options.requiredOptions - список полей, которые необходимо проверить
 * @param {string} [options.mode] - режим работы(warn, error, throw)
 */

function testRequiredOptions({ module, requiredOptions, mode = 'error' } = {}) {
  return Object.entries(requiredOptions)
    .every(([key, value]) => {
      if (value === null || value === undefined) {
        createDevNotice({
          mode,
          module,
          description: `Отсутствует обязательное поле "${key}"`,
        })

        return false
      }

      return true
    })
}

export default testRequiredOptions
